const tokenExtractor = () => {
  return `Bearer ${JSON.parse(window.localStorage.loggedUser).token}`
}

export default tokenExtractor